export const OFFER_INIT_GUID = 'OFFER_INIT_GUID';
export const OFFER_INIT_WITH_IDOFFER_PARTNERID = 'OFFER_INIT_WITH_IDOFFER_PARTNERID';
export const OFFER_UPDATE_PARAMS = 'OFFER_UPDATE_PARAMS';
export const OFFER_CHECK_GUID = 'OFFER_CHECK_GUID';
export const OFFER_COOKIE_SUCCESS = 'OFFER_COOKIE_SUCCESS';
export const OFFER_INCREMENT_STEP = 'OFFER_INCREMENT_STEP';
export const OFFER_DECREMENT_STEP = 'OFFER_DECREMENT_STEP';
export const OFFER_SET_CURRENT_STEP = 'OFFER_SET_CURRENT_STEP';
export const OFFER_STATE_PROCESS = 'OFFER_STATE_PROCESS';
export const OFFER_OPERATION_BY_GUID = 'OFFER_OPERATION_BY_GUID';
export const OFFER_CAMPAIGN_BY_ID = 'OFFER_CAMPAIGN_BY_ID';
export const OFFER_CAMPAIGN_BY_ORDER_ID = 'OFFER_CAMPAIGN_BY_ORDER_ID';
export const OFFER_OPERATION_CAMPAIGN_JOIN = 'OFFER_OPERATION_CAMPAIGN_JOIN';
export const OFFER_UPDATE = 'OFFER_UPDATE';
export const OFFER_UPDATE_FROM_GUID = 'OFFER_UPDATE_FROM_GUID';
export const OFFER_UPDATE_OPERATION = 'OFFER_UPDATE_OPERATION';
export const OFFER_CREATE_OPERATION = 'OFFER_CREATE_OPERATION';
export const OFFER_CREATE_OPERATION_DATA = 'OFFER_CREATE_OPERATION_DATA';
export const OFFER_RESULT_INSTANTOR = 'OFFER_RESULT_INSTANTOR';
export const OFFER_CAMPAIGN_BY_GUID = 'OFFER_CAMPAIGN_BY_GUID';
export const OFFER_REGISTER_SIGNATURE = 'OFFER_REGISTER_SIGNATURE';
export const OFFER_UPDATE_SIGN = 'OFFER_UPDATE_SIGN';
export const OFFER_CHECK_ELECTRONIC_SIGNATURE = 'OFFER_CHECK_ELECTRONIC_SIGNATURE';
export const OFFER_ELECTRONIC_SIGNATURE = 'OFFER_ELECTRONIC_SIGNATURE';
export const OFFER_PATCH_OPERATION = 'OFFER_PATCH_OPERATION';
export const OFFER_DOCUMENTS_REQUIRED_BY_GUID = 'OFFER_DOCUMENTS_REQUIRED_BY_GUID';
export const OFFER_UPDATE_DOCUMENTS_REQUIRED = 'OFFER_UPDATE_DOCUMENTS_REQUIRED';
export const OFFER_UPLOAD_STUDY_DOCUMENTATION = 'OFFER_UPLOAD_STUDY_DOCUMENTATION';
export const OFFER_COMPLETED = 'OFFER_COMPLETED';
export const OFFER_COMPLETED_KO = 'OFFER_COMPLETED_KO';
export const OFFER_UPDATE_COMPLETED_KO = 'OFFER_UPDATE_COMPLETED_KO';
export const PRECONTRACT_BY_GUID = 'PRECONTRACT_BY_GUID';
export const PRECONTRACT_UPDATE = 'PRECONTRACT_UPDATE';
export const OFFER_LEGAL_CONDITIONS = 'OFFER_LEGAL_CONDITIONS';
export const OFFER_LEGAL_CONDITIONS_BY_GUID = 'OFFER_LEGAL_CONDITIONS_BY_GUID';
export const OFFER_COMPONENTS_BY_PARTNER_ID = 'OFFER_COMPONENTS_BY_PARTNER_ID';
export const OFFER_OPERATION_STEPBACK = 'OFFER_OPERATION_STEPBACK';
export const STRIPE_REPAYMENT = 'STRIPE_REPAYMENT';
export const STRIPE_PAYMENT_CHECK = 'STRIPE_PAYMENT_CHECK';
